import { render, staticRenderFns } from "./VppPayments.vue?vue&type=template&id=0c9b5ff2&scoped=true"
import script from "./VppPayments.vue?vue&type=script&lang=js"
export * from "./VppPayments.vue?vue&type=script&lang=js"
import style0 from "./VppPayments.vue?vue&type=style&index=0&id=0c9b5ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9b5ff2",
  null
  
)

export default component.exports